import { CareRecipientId } from "./CareRecipientId";
import { CareRecipientName } from "./CareRecipientName";
import { DateObject } from "../fundamental/DateObject";
import { CareRecipientHouseId } from "./CareRecipientHouseId";
import { CareRecipient } from "./CareRecipient";
import { ServiceProviderId } from "../service_provider/ServiceProviderId";
import { DateTime } from "../fundamental/DateTime";

const CareRecipientWithDataSyncInformationType = Symbol();

export enum CareRecipientSortCondition {
    HOUSE_ID = "houseId",
    CARE_RECIPIENT_NAME = "name",
    DATA_SYNC_START_TIME = "dataSyncStartTime",
}

export class CareRecipientWithDataSyncInformation {
    [CareRecipientWithDataSyncInformationType]: any;

    careRecipient: CareRecipient;

    serviceProviderId: ServiceProviderId | null;

    dataSyncStartTime: DateTime | null;

    dataSyncEndTime: DateTime | null;

    alertPeriod: {
        start: DateObject,
        end: DateObject
    } | null;

    private constructor(
        careRecipientId: CareRecipientId,
        careRecipientName: CareRecipientName,
        birthday: DateObject | null,
        houseId: CareRecipientHouseId | null,
        serviceProviderId: ServiceProviderId | null,
        dataSyncStartTime: DateTime | null,
        dataSyncEndTime: DateTime | null,
        alertPeriodStart: DateObject | null,
        alertPeriodEnd: DateObject | null
    ) {
        this.careRecipient = CareRecipient.from(careRecipientId, careRecipientName, birthday, houseId);

        this.serviceProviderId = serviceProviderId;
        this.dataSyncStartTime = dataSyncStartTime;
        this.dataSyncEndTime = dataSyncEndTime;
        this.alertPeriod = (alertPeriodStart && alertPeriodEnd) && { start: alertPeriodStart, end: alertPeriodEnd };
    }

    static from(
        careRecipientId: CareRecipientId,
        careRecipientName: CareRecipientName,
        birthday: DateObject | null,
        houseId: CareRecipientHouseId | null,
        serviceProviderId: ServiceProviderId | null,
        dataSyncStartTime: DateTime | null,
        dataSyncEndTime: DateTime | null,
        alertPeriodStart: DateObject | null,
        alertPeriodEnd: DateObject | null
    ): CareRecipientWithDataSyncInformation {
        return new CareRecipientWithDataSyncInformation(careRecipientId, careRecipientName, birthday, houseId, serviceProviderId, dataSyncStartTime, dataSyncEndTime, alertPeriodStart, alertPeriodEnd);
    }
}

export type CareRecipientListJson = {
    id: string,
    name: string,
    houseId: string,
    dataSyncStartTime: string | null,
    dataSyncEndTime: string | null,
    alertPeriod: {
        start: string,
        end: string
    } | null
}[];
